export default function Education(){    
    return(
        <>
            <p>2021</p>
            <p>Graduated from Kufa University and got a bachelor's degree in English Language and Literature.</p>
        </>
    )
}